/**
 * Grafiğin yakınlaştırma düğmeleri (kullanıcı, 15.10.2026): "+" seçili
 * günün çevresine yakınlaşır, "−" uzaklaşır, "Tümü" baştaki görünüme döner.
 * Fareyle sürükleyerek aralık seçmek ve klavye (+, −, 0) da aynı işi yapar.
 */

import { EN_AZ_GUN, type Yakinlastirma } from "../lib/yakinlastirma";
import { cx } from "./primitives";
import { M } from "../dil";

const DUGME =
  "inline-flex h-6 min-w-6 items-center justify-center rounded-[var(--pf-radius-sm)] border border-line px-1.5 text-[12px] text-ink hover:bg-surface-2 disabled:cursor-default disabled:text-faint disabled:hover:bg-transparent";

export function YakinlastirmaDugmeleri({
  y,
  merkez,
  baslik,
}: {
  readonly y: Yakinlastirma;
  readonly merkez: number;
  readonly baslik: string;
}) {
  const genislik = y.pencere.son - y.pencere.bas + 1;
  return (
    <div role="group" aria-label={M.grafik.yakinlastirma.grup(baslik)} className="flex items-center gap-1">
      <button
        type="button"
        className={DUGME}
        aria-label={M.grafik.yakinlastirma.yakinlas}
        title={M.grafik.yakinlastirma.yakinlasBalon}
        disabled={genislik <= EN_AZ_GUN}
        onClick={() => y.yakinlas(merkez)}
      >
        +
      </button>
      <button
        type="button"
        className={DUGME}
        aria-label={M.grafik.yakinlastirma.uzaklas}
        title={M.grafik.yakinlastirma.uzaklasBalon}
        disabled={y.tam}
        onClick={() => y.uzaklas(merkez)}
      >
        −
      </button>
      <button
        type="button"
        className={cx(DUGME, "px-2")}
        aria-label={M.grafik.yakinlastirma.tumunu}
        title={M.grafik.yakinlastirma.tumunuBalon}
        disabled={y.tam}
        onClick={y.sifirla}
      >
        {M.grafik.yakinlastirma.tumu}
      </button>
    </div>
  );
}
